// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMessageCircle as RawLucideMessageCircle } from "lucide-react";
export const LucideMessageCircle = /* @__PURE__ */ createIcon(RawLucideMessageCircle, "LucideMessageCircle", 2);
